
    export default {
        name: 'PreviousCourses',
        props: {
            src: {
                type: String,
                required: true
            }
        }
    }
